import React from "react";

export default function Footer() {
  return (
    <div className="footer">
      <p>© 2022 sourcescrub. All rights reserved.</p>
      <ul className="footer-privacy">
        <li>
          <a href="https://www.sourcescrub.com/legal/cookie-policy">
            Cookie Policy
          </a>
        </li>
        <li>
          <a href="https://www.sourcescrub.com/legal/privacy-policy">
            Privacy Policy
          </a>
        </li>
        <li>
          <a href="https://www.sourcescrub.com/legal/end-user-license-agreement">
            EULA
          </a>
        </li>
      </ul>
      <ul className="footer-social">
        <li>
          <a href="https://twitter.com/SourceScrub">
            <img src="/images/twitter.png" alt="twitter logo" />
          </a>
        </li>
        <li>
          <a href="https://www.facebook.com/sourcescrub">
            <img src="/images/fb.png" alt="facebook logo" />
          </a>
        </li>
        <li>
          <a href="https://www.instagram.com/sourcescrub">
            <img src="/images/insta.png" alt="instagram logo" />
          </a>
        </li>
        <li>
          <a href="https://www.linkedin.com/company/sourcescrub/">
            <img src="/images/linkedin.png" alt="linkedin logo" />
          </a>
        </li>
      </ul>
    </div>
  );
}
